import { motion } from 'framer-motion'
import styled from 'styled-components'

export const LoginOverlay = motion(styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 199;
`)

export const LoginModalContainer = motion(styled.div`
	position: absolute;
	top: -4px;
	right: -3px;
	z-index: 200;
	transform-origin: top right;
`)

export const LoginModalWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	background: #fff;
	border-radius: 20px;
	padding: 15px 20px 15px 20px;
	box-sizing: border-box;
	width: 270px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	position: relative;
	z-index: 201;

	-webkit-mask-image: radial-gradient(
		circle 32px at calc(100% - 23.5px) 23.5px,
		transparent 31px,
		black 32px
	);

	img {
		max-width: 150px;
		width: 100%;
	}
	mask-image: radial-gradient(
		circle 32px at calc(100% - 23.5px) 23.5px,
		transparent 31px,
		black 32px
	);
`

export const LoginModalText = styled.div`
	font-weight: 300;
	font-size: 10px;
	color: #000;
`

export const LoginModalActions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`
export const UserCircleInModal = styled.div`
	position: absolute;
	top: 0px;
	right: 0px;
	width: 47px;
	height: 47px;
	background: #fff;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 202;

	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`
